import { render, staticRenderFns } from "./ForumPostForm.vue?vue&type=template&id=220dbcf3&scoped=true"
import script from "./ForumPostForm.vue?vue&type=script&lang=js"
export * from "./ForumPostForm.vue?vue&type=script&lang=js"
import style0 from "./ForumPostForm.vue?vue&type=style&index=0&id=220dbcf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220dbcf3",
  null
  
)

export default component.exports